export enum PRODUCTS {
  Opplevelser = 'Opplevelser',
  MinMemoria = 'MinMemoria',
  DigitaleOpplevelser = 'DigitaleOpplevelser',
  Triggo = 'Triggo',
  VR = 'VR',
  Yetitablet = 'Yetitablet',
  CatalogOfIdeas = 'CatalogOfIdeas',
  Friskus = 'Friskus',
  Dashboard = 'Dashboard',
}
